import {CurrencyDto} from "./currency-dto.model";

export class MenuItemDto {
  constructor(
    public name?: string,
    public price?: number,
    public currency?: string,
    public description?: string,
    public active?: boolean
  ) {
  }
}
